import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";
import { pack } from "./alert";

export const get = ({ personUuid } = {}) => async (dispatch) => {
    try {
        const res = isGuid(personUuid)
            ? await api.get(`/people/settings/p/${personUuid}`)
            : await api.get("/people/settings/me");
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({ type: LOGOUT });
        }
        throw err;
    }
};

export const save = ({ personUuid, settings } = {}) => async (dispatch) => {
    try {
        const res = isGuid(personUuid)
            ? await api.post(`/people/settings/p/${personUuid}`, { settings })
            : await api.post("/people/settings/me", { settings });
        dispatch(pack(["personal settings saved"], "success"));
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({ type: LOGOUT });
        } else {
            dispatch(pack(["unable to save personal settings"], "error"));
        }
        throw err;
    }
};
